import { Colors } from '../../theme';

export default {
  boxDefault: {
  },
  boxContent: {
    backgroundColor: Colors.white,
    boxShadow: '0px 1px #EBE7EC',
  }
};
